export enum VerificationStep {
  CONTACTS_INPUT = 'contacts_input',
  CODES_VERIFICATION = 'codes_verification',
}

export const CODE_LENGTH = 6;

export const CONTACTS_FORM_ID = 'contacts-verification-form';
